module.exports = __webpack_public_path__ + "media/images/vacancies-bg-01-08d5ca7d20a699a42b2dd1ebbeb1fef4.svg";